export default () => window.location.reload(true)
